// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import React from "react";

import { Box, styled, Typography } from "@3778.care/goban";
import PropTypes from "prop-types";

import { formatByToken } from "../../../../util/date";
import { useIsDesktop } from "../../../../util/useIsDesktop";
import { DateContainer } from "../DateContainer";
import { StatusChip } from "../StatusChip";

const StyledTypography = styled(Typography)(({ theme: { spacing } }) => ({
  marginBottom: spacing(0.5),
}));

const StyledBox = styled(Box)(({ theme: { breakpoints, spacing } }) => ({
  margin: spacing(2, 0, 0, 2),
  [breakpoints.up("md")]: {
    margin: spacing(3, 0.5, 0.5, 3),
  },
}));

export const AppointmentHeader = ({
  appointment,
  appointmentStatus,
  appointmentSubtitle,
}) => {
  const isDesktop = useIsDesktop();

  return (
    <Box display="flex" flexWrap="wrap" alignItems="center">
      <StyledBox>
        <DateContainer start={appointment.start}></DateContainer>
      </StyledBox>

      <Box marginLeft={1.8}>
        <StyledTypography
          color="textPrimary"
          component="h4"
          variant={isDesktop ? "h4" : "h6"}
        >
          <Box display="flex" alignItems="center">
            {`${formatByToken(appointment.start, "HH:mm")} - ${formatByToken(
              appointment.end,
              "HH:mm"
            )}`}
            <StatusChip status={appointmentStatus} />
          </Box>
        </StyledTypography>

        <Typography variant="body2" color="textSecondary">
          {appointmentSubtitle}
        </Typography>
      </Box>
    </Box>
  );
};

AppointmentHeader.propTypes = {
  appointment: PropTypes.object.isRequired,
  appointmentStatus: PropTypes.string.isRequired,
  appointmentSubtitle: PropTypes.string.isRequired,
};
